import script from "./SAM2SelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SAM2SelectBox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__